import React from 'react';
import { ICONS } from './WidgetIcons';

const DEFAULT_STEPS = [
  { icon: 'Package', title: 'انتخاب محصول', text: 'محصول مورد نظر را از فروشگاه انتخاب کنید.' },
  { icon: 'ListChecks', title: 'ثبت سفارش', text: 'مشخصات و تعداد را وارد و سفارش خود را ثبت کنید.' },
  { icon: 'CreditCard', title: 'پرداخت', text: 'پرداخت آنلاین یا هنگام تحویل را انجام دهید.' },
  { icon: 'Truck', title: 'ارسال و تحویل', text: 'سفارش را درب منزل تحویل بگیرید.' },
];

export default function SectionHowToOrder({ settings = {}, embedded }) {
  const steps = (Array.isArray(settings.steps) && settings.steps.length ? settings.steps : DEFAULT_STEPS)
    .slice(0, 6);
  const accent = settings.accentColor || 'var(--primary)';
  const cardBg = settings.cardBg || 'var(--card)';
  const layout = settings.layout || 'cards';
  const tSize = settings.titleSize ? `${settings.titleSize}px` : 'clamp(1.4rem, 4vw, 2rem)';

  const head = (
    <div style={{ textAlign: 'center', marginBottom: 30 }}>
      {settings.subtitle ? (
        <div style={{ fontSize: '0.85rem', fontWeight: 700, color: settings.subColor || accent, marginBottom: 6 }}>
          {settings.subtitle}
        </div>
      ) : null}
      <h2 className="serif" style={{ fontWeight: '700', fontSize: tSize, color: settings.titleColor || undefined, margin: 0 }}>
        {settings.sectionTitle || settings.title || 'روش سفارش'}
      </h2>
      {settings.desc ? (
        <p style={{ color: 'var(--muted-fg)', fontSize: '0.9rem', marginTop: 8, lineHeight: 1.9 }}>{settings.desc}</p>
      ) : null}
    </div>
  );

  if (layout === 'timeline') {
    return (
      <section className={embedded ? undefined : 'container'} style={embedded ? undefined : { padding: 'clamp(48px, 8vw, 88px) 20px' }}>
        {head}
        <div style={{ position: 'relative', maxWidth: 640, margin: '0 auto', paddingRight: 8 }}>
          <div aria-hidden style={{ position: 'absolute', top: 8, bottom: 8, right: 27, width: 2, background: `linear-gradient(${accent}, transparent)`, opacity: 0.35, borderRadius: 2 }} />
          {steps.map((st, i) => {
            const Icon = ICONS[st.icon] || ICONS.Sparkles;
            return (
              <div key={i} style={{ display: 'flex', gap: 16, alignItems: 'flex-start', paddingBottom: i < steps.length - 1 ? 26 : 0 }}>
                <div style={{ position: 'relative', zIndex: 1, width: 56, height: 56, borderRadius: '50%', flexShrink: 0,
                  background: `linear-gradient(135deg, ${accent}, transparent)`, padding: 2 }}>
                  <div style={{ width: '100%', height: '100%', borderRadius: '50%', background: cardBg,
                    display: 'flex', alignItems: 'center', justifyContent: 'center', color: accent }}>
                    <Icon size={24} />
                  </div>
                </div>
                <div style={{ background: cardBg, borderRadius: 'var(--shape-card)', padding: '14px 18px', border: 'var(--shape-line) solid var(--border)', flex: 1 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <span style={{ fontSize: '0.72rem', fontWeight: 800, color: accent }}>
                      {`مرحله ${Number(i + 1).toLocaleString('fa-IR')}`}
                    </span>
                    <strong className="serif" style={{ fontSize: '1.02rem' }}>{st.title}</strong>
                  </div>
                  {st.text ? <div style={{ color: 'var(--muted-fg)', fontSize: '0.88rem', lineHeight: 1.9, marginTop: 4 }}>{st.text}</div> : null}
                </div>
              </div>
            );
          })}
        </div>
      </section>
    );
  }

  // cards layout: grid with dashed connector line through the icons (desktop)
  return (
    <section className={embedded ? undefined : 'container'} style={embedded ? undefined : { padding: 'clamp(48px, 8vw, 88px) 20px' }}>
      {head}
      <div className="howto-grid" style={{ position: 'relative', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 'var(--space-3)' }}>
        <div className="howto-line" aria-hidden style={{ position: 'absolute', top: 52, right: '12%', left: '12%', borderTop: `2px dashed ${accent}`, opacity: 0.4 }} />
        {steps.map((st, i) => {
          const Icon = ICONS[st.icon] || ICONS.Sparkles;
          return (
            <div key={i} className="howto-card" style={{ position: 'relative', background: cardBg, borderRadius: 'var(--shape-card)', padding: '26px 20px 22px', border: 'var(--shape-line) solid var(--border)', textAlign: 'center', overflow: 'hidden' }}>
              <span aria-hidden className="serif" style={{ position: 'absolute', top: 2, left: 12, fontSize: '3.2rem', fontWeight: 800, lineHeight: 1, opacity: 0.08 }}>
                {Number(i + 1).toLocaleString('fa-IR')}
              </span>
              <div style={{ position: 'relative', zIndex: 1, width: 64, height: 64, borderRadius: '50%', margin: '0 auto 14px',
                background: `linear-gradient(135deg, ${accent}, transparent)`, padding: 2 }}>
                <div style={{ width: '100%', height: '100%', borderRadius: '50%', background: cardBg,
                  display: 'flex', alignItems: 'center', justifyContent: 'center', color: accent }}>
                  <Icon size={28} />
                </div>
              </div>
              <div className="serif" style={{ fontWeight: '700', marginBottom: 6, fontSize: '1.05rem' }}>{st.title}</div>
              {st.text ? <div style={{ color: 'var(--muted-fg)', fontSize: '0.88rem', lineHeight: 1.9 }}>{st.text}</div> : null}
            </div>
          );
        })}
      </div>
      <style>{`@media (max-width: 767px) {
        .howto-line { display: none !important; }
        .howto-grid { display: flex !important; flex-direction: row !important; overflow-x: auto !important; scroll-snap-type: x mandatory; gap: 12px !important; padding-bottom: 10px; }
        .howto-grid .howto-card { flex: 0 0 68% !important; scroll-snap-align: start; }
      }`}</style>
    </section>
  );
}
